import React, { useEffect, useState } from 'react';
import { FileText, ExternalLink } from 'lucide-react';
import { rb } from './theme';
import { resumeService } from '../../services/resumeService';

// Previously generated resumes. Renders nothing when empty or on error.
export default function MyResumes() {
  const [resumes, setResumes] = useState([]);

  useEffect(() => {
    (async () => {
      try {
        const data = await resumeService.getUserResumes();
        setResumes((data?.resumes || []).filter((r) => r.pdf_url));
      } catch {
        /* list is optional — hide on error */
      }
    })();
  }, []);

  if (!resumes.length) return null;

  return (
    <div className="mt-10">
      <h3 className="text-sm font-bold uppercase tracking-wide mb-3 text-slate-400">Your previous resumes</h3>
      <div className="space-y-2">
        {resumes.slice(0, 5).map((r) => (
          <a
            key={r.id}
            href={r.pdf_url}
            target="_blank"
            rel="noopener noreferrer"
            className={`flex items-center gap-3 p-3.5 rounded-2xl transition-transform hover:-translate-y-0.5 ${rb.glassSoft}`}
          >
            <span className={`w-10 h-10 rounded-xl flex items-center justify-center shrink-0 ${rb.chip}`}>
              <FileText className="w-4 h-4 text-violet-300" />
            </span>
            <div className="min-w-0 flex-1">
              <p className="text-sm font-semibold truncate text-slate-100">{r.title || 'Resume'}</p>
              <p className="text-xs text-slate-400">{r.created_at ? new Date(r.created_at).toLocaleDateString() : ''}</p>
            </div>
            <ExternalLink className="w-4 h-4 shrink-0 text-slate-400" />
          </a>
        ))}
      </div>
    </div>
  );
}
